export const environment = {
  production: false,
  // server: 'https://fakeapi.flocksocial.dev/api/v2/',
  server: 'https://api.agency-onboarding.flocksocial.io/api/v2/',
};
